import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './index.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="container">
        <div className="logo">
          <Link to="/">
            <span className="purple-star">★</span>
            <h1>Starrr's Blog</h1>
          </Link>
        </div>
        
        <nav className={`nav ${isMenuOpen ? 'open' : ''}`}>
          <Link to="/" onClick={() => setIsMenuOpen(false)}>首页</Link>
          <Link to="/archive" onClick={() => setIsMenuOpen(false)}>归档</Link>
          <Link to="/about" onClick={() => setIsMenuOpen(false)}>关于</Link>
          <Link to="/write" onClick={() => setIsMenuOpen(false)}>写文章</Link>
          <button className="btn-purple login-btn">登录</button>
        </nav>
        
        <button 
          className="menu-toggle" 
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`bar ${isMenuOpen ? 'open' : ''}`}></span>
          <span className={`bar ${isMenuOpen ? 'open' : ''}`}></span>
          <span className={`bar ${isMenuOpen ? 'open' : ''}`}></span>
        </button>
      </div>
    </header>
  );
};

export default Header;